import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { challanColdefs, DeliveryChallanPopup } from './DeliveryChallanTable';
import { decryptAES } from '../../../utils/Encryption';
import moment from 'moment';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class DeliveryChallan extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            open: false,
            isShown: false,
            isAddProductsButtonLoading: false,
            rowData: [],
            colDefs: [],
            companyName: '',
            itemRowData: [],
            itemColdefs: [],
            challanRowData: [],
            vendorRowData: [],
            tempVendorRowData: [],
            selectedRowsForItem: [],
            selectedRowsForChallanItem: [],
            challanFromList: [
                { value: 1, label: 'TAX INVOICE' },
                { value: 2, label: 'REJECTION' },
                { value: 3, label: 'SCRAP' }
            ],
            invTypeList: [
                { value: 1, label: 'INTRASTATE' }
            ],
            partyAccountList: [],
            accountHeadList: [],
            pTermsList: [
                { value: 1, label: 'NET 15' },
                { value: 2, label: 'NET 30' },
                { value: 3, label: 'NET 45' },
                { value: 4, label: 'NET 60' },
                { value: 5, label: 'NET 90' }
            ],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            isPartyNameChanged: false,
            deliveryObject: {
                idChallanInvoice: 0,
                updateStatus: 0,
                challanNo: '',
                challanDate: '',
                challanFrom: 1,
                challanType: 1,
                idVendor: 0,
                oldVendorId: 0,
                idDelivery: 0,
                idSalesInvoice: '',
                orderNo: '',
                orderDate: '',
                customerAddress: '',
                deliveryAddress: '',
                vehicleNo: "",
                transporter: "",
                idTerms: "",
                challanCategory: 'PARTY WORK ORDER',
                dueDate: null,
                totalArticle: 0,
                totalQty: 0,
                idAccountHead: 0,
                contactNo: '',
                contactPerson: '',
                email: '',
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForWork: {
                idVendor: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "customer"
                        ),
                    },
                ],
                challanDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "challan date"
                        ),
                    },
                ],
                idAccountHead: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "account head"
                        ),
                    },
                ],
            },
            validationRules: {
                product: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "product"
                        ),
                    },
                ],
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],
                idTaxStructure: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "tax group"
                        ),
                    },
                ],
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect()
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Delivery Challan",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idInvoice", "chequeDate", "sR.No"].includes(key) ? true : false,
                            pinned: ["idChallanInvoice", "challanFrom", "rejectionNo", "workOrder", "challanNo"].includes(key) ? "left" : undefined,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Delivery Challan",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Delivery Challan");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "idChallanInvoice": window.innerWidth * 0.05,
            "challanFrom": window.innerWidth * 0.08,
            "rejectionNo": window.innerWidth * 0.08,
            "workOrder": window.innerWidth * 0.06,
            "challanNo": window.innerWidth * 0.06,
            "challanDate": window.innerWidth * 0.08,
            "customer": window.innerWidth * 0.2,
            "delivery": window.innerWidth * 0.2,
            "dueDate": window.innerWidth * 0.08,
            "totalQty": window.innerWidth * 0.06,
            "status": window.innerWidth * 0.06,
            "closeStatus": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            "idChallanInvoice": window.innerWidth * 0.05,
            "challanFrom": window.innerWidth * 0.08,
            "rejectionNo": window.innerWidth * 0.08,
            "workOrder": window.innerWidth * 0.06,
            "challanNo": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            filter: true,
                            floatingFilter: true,
                            // hide: ["ssmA_TimeStamp",].includes(key) ? true : false,
                            flex: 1,
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.08,
            "itemCategory": window.innerWidth * 0.1,
            "itemName": window.innerWidth * 0.3,
            "quantity": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));

                    this.setState({ partyAccountList: dynamicData }, () => {
                        this.getMasterAccountHeadSelect();
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    this.getMasterAccountHeadSelect();
                }
            }
        });
    }

    getMasterAccountHeadSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {

                let data = response.responseItem.responseContent;
                let result = data
                    .map((x) => ({
                        value: x.idGeneralProduct,
                        label: x.productName,
                    }))
                    .filter((x) => x.label === 'SALES');
                this.setState({ accountHeadList: result });
            }
        });
    }

    handleCellClick = (event) => {
        let data = this.state.deliveryObject;
        data.idSalesInvoice = event.data[this.state.colName];
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ deliveryObject: data, validState: validState })
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Delivery Challan");
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ open: false })
        this.transactionStockServices.getInvoiceCountForDeliveryChallan(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let total = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (total.toString().length === 1) {
                    formatted = '00' + total;
                } else if (total.toString().length === 2) {
                    formatted = '0' + total;
                } else {
                    formatted = total.toString();
                }
                let deliveryObject = this.state.deliveryObject
                deliveryObject.challanNo = formatted
                deliveryObject.challanDate = moment(new Date()).format('YYYY-MM-DD')
                this.setState({ deliveryObject: deliveryObject }, () => {

                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        // this.resetInvoiceItems()
                        this.setState({ invoiceRowData: [] })
                    })
                })
            }
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.setState({ open: false })
        this.getTransactionDeliveryChallanByID(event.data.idChallanInvoice);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForWork = () => {
        const newValidState = isValidForm(
            this.state.deliveryObject,
            this.state.validationRulesForWork,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForWork = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.deliveryObject;
        details[name] = value;
        this.setState({ deliveryObject: details });
    }
    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details });
    }

    resetDetailsFields = () => {
        let details = this.state.deliveryObject;
        details.idChallanInvoice = 0;
        details.updateStatus = 0;
        details.challanFrom = 1;
        details.challanType = 1;
        details.idVendor = 0;
        details.idDelivery = 0;
        details.idSalesInvoice = '';
        details.orderNo = '';
        details.orderDate = '';
        details.customerAddress = '';
        details.deliveryAddress = '';
        details.vehicleNo = "";
        details.transporter = "";
        details.idTerms = 1;
        details.challanCategory = 'PARTY WORK ORDER';
        details.dueDate = null;
        details.totalArticle = 0;
        details.totalQty = 0;
        details.idAccountHead = 0;

        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState,
            deliveryObject: details,
            itemRowData: [],
            vendorRowData: [],
            challanRowData: []
        });
    }

    setFilterParameters = (event, name) => {
        let details = this.state.deliveryObject;
        details[name] = event.value;
        if (name === 'idDelivery') {
            details.deliveryAddress = event.partyAddress
        }
        if (name === 'idVendor') {
            details.customerAddress = event.partyAddress
            details.idDelivery = event.value
            details.deliveryAddress = event.partyAddress
            if (this.state.deliveryObject.oldVendorId !== event.value && this.state.deliveryObject.updateStatus === 1) {
                this.setState({ isPartyNameChanged: true })
            } else {
                this.setState({ isPartyNameChanged: false })
            }
        }
        this.setState({ deliveryObject: details });
    }


    addWorkOrder = () => {
        if (this.state.deliveryObject.challanFrom === 2) {
            this.getWorkOrderSalesInvoiceByVendorIdForRejection();
        } else {
            this.getWorkOrderSalesInvoiceByVendorIdforTaxInvoice();
        }
    }
    getWorkOrderSalesInvoiceByVendorIdforTaxInvoice = () => {
        if (this.state.deliveryObject.idVendor > 0) {
            let request = {
                idCompany: this.state.idCompany,
                updateStatus: this.state.deliveryObject.updateStatus,
                idSalesInvoice: this.state.deliveryObject.idSalesInvoice,
                idVendor: this.state.deliveryObject.idVendor
            }
            this.transactionStockServices.getWorkOrderSalesInvoiceByVendorIdforTaxInvoice(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent.workOrderRecvs;
                    dynamicData.map(x => {
                        x.refNo = x?.woRecvNo
                        x.refDate = x.woRecvDate ? moment(x.woRecvDate).format('DD-MM-YYYY') : '';
                    })
                    let dynamicDataForItem = response.responseItem.responseContent.details;
                    dynamicDataForItem.map(x => {
                        x.id = x.idwoOrderRecv
                        x.itemId = x.idwoOrderRecvItems;
                    })
                    const itemWoRecvNos = new Set(dynamicDataForItem.map(x => x.woRecvNo).filter(Boolean));
                    dynamicData = dynamicData.filter(x => itemWoRecvNos.has(x.woRecvNo));
                    this.setState({
                        challanRowData: dynamicData,
                        tempVendorRowData: dynamicDataForItem,
                        open: true
                    }, () => {
                        this.filterVendorRowData(this.state.tempVendorRowData[0]?.woRecvNo)
                    });
                }
            })
        } else {
            this.SwalServices.Alert('Please select customer first')
        }
    }

    filterVendorRowData = (refNoArray) => {
        let arr = this.state.tempVendorRowData
        if (this.state.deliveryObject.challanFrom === 2) {
            arr = arr.filter(x => refNoArray.includes(x.rejectionNo))
        } else {
            arr = arr.filter(x => refNoArray.includes(x.woRecvNo))
        }
        this.setState({ vendorRowData: arr })
    }

    getWorkOrderSalesInvoiceByVendorIdForRejection = () => {
        if (this.state.deliveryObject.idVendor > 0) {
            let request = {
                idCompany: this.state.idCompany,
                updateStatus: this.state.deliveryObject.updateStatus,
                idSalesInvoice: this.state.deliveryObject.idSalesInvoice,
                idVendor: this.state.deliveryObject.idVendor
            }
            this.transactionStockServices.getWorkOrderSalesInvoiceByVendorIdForRejection(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent.workOrderRecvs;
                    dynamicData.map(x => {
                        x.refNo = x.rejectionNo
                        x.refDate = x.rejectionDate ? moment(x.rejectionDate).format('DD-MM-YYYY') : '';
                    })
                    let dynamicDataForItem = response.responseItem.responseContent.details;
                    dynamicDataForItem.map(x => {
                        x.id = x.idMaterialRejection
                        x.itemId = x.idMaterialRejectionItems;
                    })
                    const itemRejectionNos = new Set(dynamicDataForItem.map(x => x.rejectionNo).filter(Boolean));
                    dynamicData = dynamicData.filter(x => itemRejectionNos.has(x.rejectionNo));
                    this.setState({
                        challanRowData: dynamicData,
                        tempVendorRowData: dynamicDataForItem,
                        open: true
                    }, () => {
                        this.filterVendorRowData(this.state?.tempVendorRowData[0]?.rejectionNo)
                    });
                }
            })
        } else {
            this.SwalServices.Alert('Please select customer first')
        }
    }

    back = () => {
        this.setState({ open: false })
    }

    onSelectionChanged = (selectedRows) => {
        this.setState({ selectedRowsForItem: selectedRows }, () => {
            if (this.state.deliveryObject.challanFrom === 2) {
                this.filterVendorRowData(this.state.selectedRowsForItem.map(x => x.rejectionNo))
            } else {
                this.filterVendorRowData(this.state.selectedRowsForItem.map(x => x.woRecvNo))

            }
        })
    };

    onItemSelectionChanged = (selectedRows) => {
        this.setState({ selectedRowsForChallanItem: selectedRows })
    };

    addProduct = () => {
        if (this.state.deliveryObject.challanFrom === 2) {
            this.usp_Transaction_MaterialRejectionSelectbyId_PendingQty_ForChallan2();
        } else {
            this.workOrderRecvSelectbyId_PendingQty();
        }
    }

    workOrderRecvSelectbyId_PendingQty = async () => {
        if (this.state.selectedRowsForItem.length > 0) {
            const allRequests = [];
            this.setState({ isAddProductsButtonLoading: true })
            for (const item of this.state.selectedRowsForItem) {
                const itemArr = this.state.selectedRowsForChallanItem.length > 0
                    ? this.state.selectedRowsForChallanItem
                    : this.state.vendorRowData;

                for (const challanItem of itemArr) {
                    const request = {
                        idWOOrderRecv: item.idwoOrderRecv,
                        updateStatus: this.state.deliveryObject.updateStatus,
                        idChallanInvoice: this.state.deliveryObject.idChallanInvoice,
                        idwoOrderRecvItems: challanItem.idwoOrderRecvItems
                    };

                    allRequests.push(
                        this.transactionStockServices.workOrderRecvSelectbyId_PendingQty(request).then(response => {
                            if (response.statusCode === 200 && response.responseItem !== null) {
                                return response.responseItem.responseContent.map(x => ({
                                    ...x,
                                    woRecvNo: item.woRecvNo,
                                    woRecvDate: moment(item.woRecvDate).format('DD-MM-YYYY'),
                                    qty: 0,
                                }));
                            }
                            return [];
                        })
                    );
                }
            }

            // Wait for all API responses
            const results = await Promise.all(allRequests);
            const flattenedData = results.flat();
            this.setState({ isAddProductsButtonLoading: false })

            const existingData = this.state.itemRowData || [];
            const existingKeys = new Set(
                existingData.map(x => `${x.idItem}_${x.woRecvNo}`)
            );
            const newUniqueData = flattenedData.filter(
                x => !existingKeys.has(`${x.idItem}_${x.woRecvNo}`)
            );
            const mergedData = [...existingData, ...newUniqueData];

            this.setState({ itemRowData: mergedData }, () => {
                if (mergedData.length > 0) {
                    const totalQty = mergedData.reduce((acc, item) => acc + (item.qty || 0), 0);

                    const woOrderNos = [...new Set(
                        mergedData
                            .map(x => x.woRecvNo)
                            .filter(x => x)
                    )].join(', ');

                    let details = { ...this.state.deliveryObject, totalQty, orderNo: woOrderNos };
                    this.setState({
                        open: false,
                        deliveryObject: details
                    });
                }
            });
        }
    };



    usp_Transaction_MaterialRejectionSelectbyId_PendingQty_ForChallan2 = () => {
        let idMaterialRejection = this.state.selectedRowsForItem[0].idMaterialRejection
        let rejectionNo = this.state.selectedRowsForItem[0].rejectionNo
        let request = {
            idMaterialRejection: idMaterialRejection,
            updateStatus: this.state.deliveryObject.updateStatus,
            idChallanInvoice: this.state.deliveryObject.idChallanInvoice,
        }
        this.transactionStockServices.usp_Transaction_MaterialRejectionSelectbyId_PendingQty_ForChallan2(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent
                dynamicData.map(x => {
                    x.rejectionNo = rejectionNo
                    x.qty = x.quantity ? x.quantity : 0
                    x.woRecvDate = moment(this.state.selectedRowsForItem?.[0].woRecvDate).format('DD-MM-YYYY')
                })
                if (dynamicData.length > 0) {
                    let totalQty = dynamicData.reduce((acc, item) => acc + (item.qty || 0), 0);
                    let details = this.state.deliveryObject;
                    details.totalQty = totalQty;
                    this.setState({
                        itemRowData: dynamicData,
                        open: false,
                        deliveryObject: details
                    });
                }
            }
        })
    }

    removeChallanItem = (rowData) => {
        if (!rowData) return;
        const filtered = this.state.itemRowData.filter(
            x => !(x.idItem === rowData.idItem
                && (x.woRecvNo || '') === (rowData.woRecvNo || '')
                && (x.rejectionNo || '') === (rowData.rejectionNo || ''))
        );
        const totalQty = filtered.reduce((acc, item) => acc + (item.qty || 0), 0);
        const woOrderNos = [...new Set(
            filtered
                .map(x => x.woRecvNo)
                .filter(x => x)
        )].join(', ');
        const details = { ...this.state.deliveryObject, totalQty, orderNo: woOrderNos };
        this.setState({ itemRowData: filtered, deliveryObject: details });
    }

    isValidQuantity = () => {
        const itemRowData = this.state.itemRowData;

        for (let index = 0; index < itemRowData.length; index++) {
            const item = itemRowData[index];
            if (item.qty > item.avlStock) {
                this.SwalServices.Error(`Quantity at row ${index + 1} exceeds available stock (${item.avlStock}).`);
                return false;
            } else if (item.qty <= 0) {
                this.SwalServices.Error(`Please enter valid quantity for item at row ${index + 1}.`);
                return false;
            }
        }

        return true;
    }

    submit = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        const isValidAllFields = this.isValidAllFieldsForWork();
        const isValidQuantity = this.isValidQuantity();
        if (isValidAllFields && isValidQuantity) {
            if (this.state.itemRowData.length === 0) {
                this.SwalServices.Error("Please add required details.");
            } else {
                let details = this.state.deliveryObject;
                let details2 = this.state.itemRowData;
                let deliveryChallanItemList = [];
                details2.map((x) => {
                    let request = {
                        drawingNo: x.drawingNo,
                        itemType: x.itemType,
                        remarks: x.remarks ? x.remarks : '',
                        displaySerialNo: x.displaySerialNo ? x.displaySerialNo : '',
                        idItem: x.idItem,
                        wOQty: x.pendingQty ? x.pendingQty : 0,
                        quantity: x.qty ? x.qty : 0,
                        isTaxOrRejection: details.challanFrom === 'REJECTION' ? 1 : 0,
                        avlStock: x.avlStock,
                        iDWorkOrderRecv: x.idwoOrderRecv,
                        iDWorkOrderRecvItems: x.idwoOrderRecvItems,
                        iDMaterialRejection: x.idMaterialRejection ? x.idMaterialRejection : 0,
                        iDMaterialRejectionItems: x.idMaterialRejectionItems ? x.idMaterialRejectionItems : 0,
                    }
                    deliveryChallanItemList.push(request);
                });
                if (details !== "") {
                    let requestData = {
                        idChallanInvoice: details.idChallanInvoice,
                        challanNo: details.challanNo,
                        updateStatus: details.updateStatus,
                        challanDate: (details.challanDate && details.challanDate !== 'Invalid date') ? details.challanDate : null,
                        challanFrom: details.challanFrom > 0 ? this.state.challanFromList.find(x => x.value === details.challanFrom).label : '',
                        idAccountHead: details.idAccountHead,
                        challanCategory: details.challanCategory,
                        intWONumber: 0,
                        IdWOOrderRecv: 0,
                        challanType: details.challanType > 0 ? this.state.invTypeList.find(x => x.value === details.challanType).label : '',
                        idCustomer: details.idVendor,
                        idDelivery: details.idDelivery,
                        paymentTerms: details.idTerms ? this.state.pTermsList.find(x => x.value === details.idTerms).label : '',
                        dueDate: (details.dueDate && details.dueDate !== 'Invalid date') ? details.dueDate : null,
                        orderNo: details.orderNo,
                        orderDate: (details.orderDate && details.orderDate !== 'Invalid date') ? details.orderDate : null,
                        vehicleNo: details.vehicleNo,
                        transporter: details.transporter,
                        totalQty: details.totalQty,
                        totalArticle: details.totalArticle,
                        remarks: '',
                        idCompany: this.state.idCompany,
                        e_Date: details.e_Date ? details.e_Date : new Date(),
                        e_IDUser: this.state.idUser,
                        isUpdated: details.updateStatus > 0 ? true : false,
                        updatedDate: details.updateStatus > 0 ? new Date() : null,
                        u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
                        isDeleted: false,
                        deletedDate: null,
                        d_IDUser: 0,
                        isPartyNameChanged: this.state.isPartyNameChanged,
                        deliveryChallanItemList: deliveryChallanItemList,
                    }
                    this.isSubmitting = true;
                    this.setState({ isSaving: true });
                    this.transactionStockServices.submitDeliveryChallanInsertUpdate(requestData)
                        .then((response) => {
                            if (response.statusCode == 200 && response.responseItem !== null) {
                                let dynamicData = response.responseItem.responseContent;
                                if (dynamicData !== null) {
                                    if (this.state.deliveryObject.updateStatus === 1) {
                                        this.SwalServices.Success("Updated successfully.");
                                    } else {
                                        this.SwalServices.Success("Saved successfully.");
                                    }
                                    if (this.state.urlId) {
                                        this.setState({ route: '/ledger-report' });
                                    } else {
                                        this.resetDetailsFields();
                                        this.setState(
                                            { isModalOpen: false },
                                            () => {
                                                this.procSelectAllRecordsSP();
                                            }
                                        );
                                    }
                                } else {
                                    this.procSelectAllRecordsSP();
                                }
                            } else {
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.SwalServices.Error(response.message);
                                        this.procSelectAllRecordsSP();
                                    }
                                );
                            }
                        }).finally(() => {
                            this.isSubmitting = false;
                            this.setState({ isSaving: false });
                        });
                }
            }
        }
    }

    getTransactionDeliveryChallanByID = (id) => {
        this.transactionStockServices.getTransactionDeliveryChallanByID(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                if (res) {
                    let data = this.state.deliveryObject;
                    data.idChallanInvoice = res.idChallanInvoice;
                    data.challanNo = res.challanNo;
                    data.updateStatus = 1;
                    data.challanDate = res.challanDate ? moment(res.challanDate).format('YYYY-MM-DD') : "";
                    data.challanFrom = res.challanFrom ? this.state.challanFromList.find(x => x.label === res.challanFrom)?.value || 1 : 1;
                    data.challanType = res.challanType ? this.state.invTypeList.find(x => x.label === res.challanType)?.value || 1 : 1;
                    data.idVendor = res.idCustomer;
                    data.oldVendorId = res.idCustomer;
                    data.idDelivery = res.idDelivery;
                    data.customerAddress = res.idCustomer ? this.state.partyAccountList.find(x => x.value === res.idCustomer)?.partyAddress || "" : "";
                    data.deliveryAddress = res.idDelivery ? this.state.partyAccountList.find(x => x.value === res.idDelivery)?.partyAddress || "" : "";
                    data.orderNo = res.orderNo;
                    data.orderDate = res.orderDate ? moment(res.orderDate).format('YYYY-MM-DD') : "";
                    data.vehicleNo = res.vehicleNo;
                    data.transporter = res.transporter;
                    data.idAccountHead = res.idGeneralProduct;
                    data.idTerms = res.paymentTerms ? this.state.pTermsList.find(x => x.label === res.paymentTerms)?.value || 1 : 1;
                    data.e_Date = res.e_Date ? res.e_Date : null;
                    data.idCustomer = res.idCustomer;
                    this.setState({
                        deliveryObject: data,
                        isModalOpen: true
                    }, () => {
                        this.getPartyAccountSelectbyID()
                    });
                    this.transactionStockServices.getTransactionDeliveryChallanItemsByID(id).then((responseData) => {
                        if (responseData.statusCode == 200 && responseData.responseItem !== null) {
                            let value = responseData.responseItem.responseContent;
                            if (value.length > 0) {
                                value.map((x) => {
                                    x.qty = x.quantity ? x.quantity : 0;
                                    x.pendingQty = x.woQuantity ? x.woQuantity : 0;
                                    x.woRecvDate = x.woRecvDate ? moment(x.woRecvDate).format('DD-MM-YYYY') : '';
                                });
                                let totalQty = value.reduce((acc, item) => acc + (item.qty || 0), 0);
                                let details = this.state.deliveryObject;
                                details.totalQty = totalQty;

                                let woOrderNos = [...new Set(
                                    value
                                        .map(x => x.woRecvNo)
                                        .filter(x => x)
                                )].join(', ');
                                details.orderNo = woOrderNos;
                                this.setState({ itemRowData: value, deliveryObject: details });
                            }
                        }
                    });

                }
            }
        });
    }

    generateDeliveryChallanInvoice = () => {
        if (this.state.deliveryObject.idChallanInvoice > 0) {
            let request = [this.state.deliveryObject.idChallanInvoice];
            this.transactionStockServices.downloadDeliveryChallanInvoice(request).then((response) => {
                if (response.status == 200 && response !== null) {
                    var file = new Blob([response.data], { type: "application/pdf" });

                    var fileURL = URL.createObjectURL(file);

                    window.open(fileURL, "_blank");

                    this.setState({
                        isModalOpen: false
                    });
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    shareOnWhatsApp = () => {
        if (this.state.deliveryObject.idChallanInvoice > 0) {
            let request = [
                this.state.deliveryObject.idChallanInvoice,
                "DeliveryChallan"
            ];
            this.transactionStockServices.shareOnWhatsApp(request).then((response) => {
                if (response.statusCode == 200 && response !== null) {
                    if (response.responseItem.responseContent) {
                        const link = response.responseItem.responseContent;
                        const phoneNumber = this.state.deliveryObject.contactNo || "";
                        const message = `Dear Customer ${this.state.deliveryObject.contactPerson || ""},  
-> Please find attached your Delivery Challan.  
-> You can view or download it using the link below:    
-> ${link}  
                                        
Thank you for your business!`;
                        const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                        window.open(whatsappLink, "_blank");
                    } else {
                        this.SwalServices.Error("No data found");
                    }
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }

    };

    sendOnEmail = () => {
        if (this.state.deliveryObject.idChallanInvoice && this.state.deliveryObject.email) {
            let request = [
                this.state.deliveryObject?.email,
                this.state.deliveryObject.idChallanInvoice,
                this.state.companyName,
                "DeliveryChallan"
                //"InvoiceTempletes\\PurchaseOrderInvoices"
            ];
            this.transactionStockServices.sendPurchaseInvoiceMail(request).then((response) => {
                if (response.responseItem !== null && response.statusCode === 200) {
                    this.SwalServices.Success("Invoice snet sucessfully.");
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        } else {
            this.SwalServices.Error("No data found");
        }
    };

    getPartyAccountSelectbyID = () => {
        if (this.state.deliveryObject.idVendor > 0) {
            this.accountTransactionServices.getPartyAccountSelectbyID(this.state.deliveryObject.idVendor).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    let data = this.state.deliveryObject;
                    data.address = res.p_Address;
                    data.email = res.emailID;
                    data.contactNo = res.contactNo;
                    data.contactPerson = res.contactPerson;
                    this.setState({ deliveryObject: data });
                }
            });
        }
    }

    render() {
        return (
            <div className='manual-invoice'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <DeliveryChallanPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            deliveryObject={this.state.deliveryObject}
                            itemObject={this.state.itemObject}
                            handleChangeForWork={this.handleChangeForWork.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            itemColdefs={this.state.itemColdefs}

                            challanFromList={this.state.challanFromList}
                            invTypeList={this.state.invTypeList}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                            partyAccountList={this.state.partyAccountList}
                            accountHeadList={this.state.accountHeadList}
                            pTermsList={this.state.pTermsList}
                            addWorkOrder={this.addWorkOrder.bind(this)}
                            open={this.state.open}
                            back={this.back.bind(this)}
                            challanRowData={this.state.challanRowData}
                            vendorRowData={this.state.vendorRowData}
                            onSelectionChanged={this.onSelectionChanged.bind(this)}
                            addProduct={this.addProduct.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            handleCellClickItemList={this.filterVendorRowData.bind(this)}
                            onItemSelectionChanged={this.onItemSelectionChanged.bind(this)}
                            isAddProductsButtonLoading={this.state.isAddProductsButtonLoading}
                            gridApi={this.gridApi}
                            sendOnEmail={this.sendOnEmail.bind(this)}
                            shareOnWhatsApp={this.shareOnWhatsApp.bind(this)}
                            generateDeliveryChallanInvoice={this.generateDeliveryChallanInvoice.bind(this)}
                            removeChallanItem={this.removeChallanItem.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 450px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Sales invoice</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    headerHeight={65}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    onCellClicked={this.handleCellClick}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
